// action types
export const ActionTypes = {
  SET_DYNAMIC_PAGE_DATA: 'dynamic_page/set_data',
};

export const setDynamicPageData = (payload: any) => ({
  type: ActionTypes.SET_DYNAMIC_PAGE_DATA,
  payload,
});
